import {captureEvent, captureException, captureMessage} from '@sentry/browser';

interface SentryType {
    captureEvent: typeof captureEvent;
    captureException: typeof captureException;
    captureMessage: typeof captureMessage;
}

const Sentry: SentryType = {
    captureEvent: () => '',
    captureException: () => '',
    captureMessage: () => '',
};

// Using Hat's Sentry functionality
export const initializeSentry = (sentry: SentryType) => {
    Sentry.captureEvent = sentry.captureEvent;
    Sentry.captureException = sentry.captureException;
    Sentry.captureMessage = sentry.captureMessage;
};

export default Sentry;
